<div class="custom-cb mr-2">
    <label class="checkbox-container" [for]="inputId">
        <input type="checkbox" [checked]="accepted" (change)="onAccept($event.target.checked)" [id]="inputId"/>
        <span class="checkbox"></span>
        <span [innerHtml]="text"></span>
    </label>
</div>
